import { Dialog, DialogContent, Slide } from "@mui/material";
import { forwardRef } from "react";
import VoterSyncPopup from "./VoterSyncPopup";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LaunchPopup = ({
  isOpen = true,
  handleClose
}) => {
  return <Dialog
    open={isOpen}
    TransitionComponent={Transition}
    keepMounted
    onClose={handleClose}
    maxWidth={"lg"}
    aria-describedby="alert-dialog-slide-description"
    className="p-3 overflow-visible max-sm:top-[20px]"
    PaperProps={{
      sx: {
        '@media (max-width: 575px)': {
          position: 'relative',
          bottom: '-40px'
        }
      }
    }}
    sx={{
      '& .MuiPaper-root.MuiPaper-elevation': {
        overflow: 'visible'
      },
    }}
  >
    <div className="vsl-product-ribbon"></div>
    <DialogContent component={"div"}
      sx={{
        padding: '0',
        zIndex: 1000
      }}
    >
      <div>
        <VoterSyncPopup
          handleClose={handleClose}
        />
      </div>
    </DialogContent>
  </Dialog>
}

export default LaunchPopup;